// extracted by mini-css-extract-plugin
export default {"empty":"DimensionValue_empty__H76AF"};